import { cn } from "@EspaceParkQC/sdk-react";
import { ChevronDown } from "lucide-react";

export function DebugButton({
  label,
  onClick,
  toggled,
}: {
  label: string;
  onClick: () => void;
  toggled: boolean;
}): React.ReactElement {
  return (
    <button
      type="button"
      aria-expanded={toggled}
      aria-haspopup="true"
      className={cn(
        "group flex h-[50px] min-w-[9.25rem] items-center justify-between gap-2 rounded-full",
        "bg-primary px-4 text-primary-foreground",
        "border border-primary-foreground/20 shadow-lg shadow-primary/20",
        "transition-[transform,box-shadow,background-color] duration-200 ease-out",
        "hover:-translate-y-0.5 hover:bg-primary/90 hover:shadow-xl hover:shadow-primary/30",
        "active:translate-y-0 active:scale-[0.98]",
        "focus-visible:ring-ring focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-background focus-visible:outline-none",
        toggled && "ring-primary/35 ring-2 ring-offset-0"
      )}
      onClick={onClick}
    >
      <span className="text-[14px] font-medium select-none">{label}</span>
      <ChevronDown
        aria-hidden
        className={cn(
          "size-4 shrink-0 transition-transform duration-200 ease-out",
          toggled ? "rotate-180" : "group-hover:translate-y-px"
        )}
      />
    </button>
  );
}
